import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import colour from 'client/utils/constants/GDS/js/color';

const defaultSize = 30;

const LineIcon = ({ color, lineCap, lineJoin, lineDash, lineDashOffset, miterLimit, width, ...props }) => {
    const canvasRef = useRef();

    useEffect(() => {
        updateCanvas();
    }, [color, lineCap, lineJoin, lineDash, lineDashOffset, miterLimit, width]);

    const updateCanvas = () => {
        const canvas = canvasRef.current;
        if (!canvas) {
            return;
        }

        const ctx = canvas.getContext('2d');
        if (!ctx) {
            return;
        }

        // Reset canvas when updating, otherwise previous drawings remain
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.strokeStyle = color;
        ctx.lineCap = lineCap;
        ctx.lineJoin = lineJoin;
        if (lineDash) {
            ctx.setLineDash(lineDash);
        }
        ctx.setMiterLimit = miterLimit;
        ctx.lineDashOffset = lineDashOffset;
        ctx.lineWidth = width;
        ctx.moveTo(5, defaultSize / 2);
        ctx.lineTo(defaultSize - 5, defaultSize / 2);
        ctx.stroke();
    };

    return (
        <canvas
            ref={canvasRef}
            width={defaultSize}
            height={defaultSize}
            data-testid={props['data-testid']}
        />
    );
};

LineIcon.propTypes = {
    color: PropTypes.string,
    lineCap: PropTypes.oneOf(['butt', 'round', 'square']),
    lineJoin: PropTypes.oneOf(['bevel', 'round', 'miter']),
    lineDash: PropTypes.arrayOf(PropTypes.number),
    lineDashOffset: PropTypes.number,
    miterLimit: PropTypes.number,
    width: PropTypes.number,
    'data-testid': PropTypes.string
};

LineIcon.defaultProps = {
    color: colour.black,
    lineCap: 'round',
    lineJoin: 'round',
    lineDashOffset: 0,
    miterLimit: 10,
    width: 3
};

export default LineIcon;
